import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NOTE: withCredentials is intentionally OFF.
// Emergent's platform proxy forces `Access-Control-Allow-Origin: *` on responses,
// which the browser refuses to combine with credentials. Auth is done via the
// `Authorization: Bearer <token>` header below (token stored in localStorage).
export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
